import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('netlify'),
  requiresOAuthFlow: true,
  avatarPath: avatars.netlify,
  logoPath: logos.netlify
});
